import { Dropdown, Menu, Typography } from 'antd'
import { RightOutlined } from '@ant-design/icons'
import * as React from 'react'
import { Link as ReactRouterLink } from 'react-router-dom'

import { ButtonLabel } from '../buttons/ButtonLabel'
import { useToggle } from '../hooks'

import * as styles from './Separator.module.less'

const { Text } = Typography

const separatorRenderDefault: React.ReactNode = <RightOutlined />

export interface SeparatorProps {
    Link?: any
    linkList?: { label: React.ReactNode; url: string }[]
    islinkListLoading?: boolean
    id?: string
    path: string
    onDropDownClick?: (args: { id: string; url: string }) => void
    onLinkClick?: (path: string) => void
    separatorRender?: React.ReactNode
}

export const Separator: React.FC<SeparatorProps> = (props) => {
    const {
        id,
        islinkListLoading,
        linkList,
        onDropDownClick,
        path,
        separatorRender: separatorRenderProps
    } = props
    const separatorRender = separatorRenderProps || separatorRenderDefault
    const { active, toggleOn, toggleOff } = useToggle()

    const Link = props.Link !== undefined ? props.Link : ReactRouterLink

    const onButtonClick = () => {
        if (onDropDownClick) {
            if (id) {
                onDropDownClick({ id, url: path })
                toggleOn()
            }
        }
        if (!onDropDownClick && linkList) {
            toggleOn()
        }
    }

    const onVisibleChange = (visible: boolean) => {
        if (!visible) {
            toggleOff()
        }
    }

    const onLinkClick = (url: string) => {
        if (props.onLinkClick) {
            props.onLinkClick(url)
        }
    }

    const button = (
        <ButtonLabel onClick={onButtonClick} active={active}>
            <Text type="secondary" className={styles.separator}>
                {separatorRender}
            </Text>
        </ButtonLabel>
    )

    return linkList && linkList?.length > 0 ? (
        <Dropdown
            onVisibleChange={onVisibleChange}
            overlay={
                <Menu>
                    {islinkListLoading
                        ? null
                        : linkList.map((link) => {
                              return (
                                  <Menu.Item key={`${link.url}${link.label}`}>
                                      <Link
                                          to={link?.url}
                                          onClick={() => onLinkClick(link.url)}
                                      >
                                          {link.label}
                                      </Link>
                                  </Menu.Item>
                              )
                          })}
                </Menu>
            }
            trigger={['click']}
            visible={active}
        >
            {button}
        </Dropdown>
    ) : (
        button
    )
}
